import { v4 as uuid } from "uuid";
import {Model} from "../../base/Model";
import DB from "../../DB";
import {Collection} from "../../base/Collection";
import DateHelperClass from '@/helpers/DateHelper' 



export class MapModel extends Model  {
    id: number;
    name: string = "";
    path_lower: string;
    path_display: string;
    path: string;
    time_invited: string;
    is_team_folder: boolean;
    shared_folder_id: string;
    is_inside_team_folder: boolean;
    parentId: string;
    pathElements: any;
    parentName:string;
    lastKey:any;
    level:number;
    settings:Model = new Model();
    constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data, {settings: Model});
        }
        
        //if(!data?.settings) {
            this.settings = new Model();
        //}
        
    }
    
}